import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { buttonMessages } from './messages';
import type { ButtonType } from './types';
import { StyledButton } from './wrappers';

export { coreButtonStyles } from './wrappers';
export type { ButtonType };

/**
 * Props for Button
 */
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** The type of button -- determines color. Note: prop `type` conflicts with HTML button prop */
  buttonType?: ButtonType;
  /** Whether or not the button is loading */
  loading?: boolean;
}

/**
 * Button Component that renders a button on the privacy page, such as the submit button in a form.
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ loading, disabled, children, ...props }, ref) => {
    const { formatMessage } = useIntl();
    return (
      <StyledButton
        disabled={typeof disabled === 'boolean' ? disabled : loading}
        ref={ref}
        {...props}
      >
        {loading ? formatMessage(buttonMessages.loading) : children}
      </StyledButton>
    );
  },
);
